module.exports = __webpack_public_path__ + "static/2_mobile-e89eb7419657ef140638209c616437ec.jpg";